export default __webpack_public_path__ + "static/media/bg.7344468d.webp";